import React from 'react';
import PropTypes from 'prop-types';
import ProductSlider from 'components/contentpage-product-slider';

export default function CmsTopicSlider({ title, products, link, lead }) {
    let _link = link ? link.to : null;

    if (!products || products.length === 0) {
        return null;
    }

    return (
        <ProductSlider
            skipTests={true}
            title={title}
            lead={lead}
            products={products}
            link={_link}
            appendPromotionTile={!!(link && link.to)}
        />
    );
}

CmsTopicSlider.propTypes = {
    title: PropTypes.string,
    lead: PropTypes.string,
    link: PropTypes.object,
    products: PropTypes.array,
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/components/cms-placeholder/products-slider/index.js